export default __webpack_public_path__ + "static/media/Kathleen_500_500.f217be5b.png";